import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-public-holidays',
  templateUrl: './public-holidays.component.html'
})
export class PublicHolidaysComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
